import React, { useState } from 'react';
import {
  Col, Grid, Nav, Panel, Row,
} from 'rsuite';
import AlzaShipments from '../components/Shipments/Alza/AlzaShipments';
import PickupLists from '../components/Shipments/PickupLists/PickupLists';

const PICKUP_LISTS_TAB = 'tabPickupLists';
const ALZA_TAB = 'tabAlza';

interface TabContentProps {
  activeKey: string;
}

function TabContent({ activeKey }: TabContentProps): JSX.Element | null {
  if (activeKey === PICKUP_LISTS_TAB) {
    return <PickupLists />;
  }
  if (activeKey === ALZA_TAB) {
    return <AlzaShipments />;
  }

  return null;
}

export default function Shipments() {
  const [activeTab, setActiveTab] = useState(PICKUP_LISTS_TAB);

  return (
    <Panel className="h100p">
      <Grid fluid className="h100p">
        <Row>
          <Col xs={24}>
            <Nav appearance="subtle" activeKey={activeTab} onSelect={setActiveTab}>
              <Nav.Item eventKey={PICKUP_LISTS_TAB}>Pickup lists</Nav.Item>
              <Nav.Item eventKey={ALZA_TAB}>Alza</Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row className="table-container">
          <Col className="mt-10 h100p" xs={24}>
            <TabContent activeKey={activeTab} />
          </Col>
        </Row>
      </Grid>
    </Panel>
  );
}
